import { api } from './_api-client';
import { ClipConfig } from './clip.service';

// T Y P E S

/**
 * Represents a scene cut detection feature
 */
export interface CutFeature {
  timestamp: number;
  score: number;
}

/**
 * Represents a flash detection feature (brightness spike)
 */
export interface FlashFeature {
  timestamp: number;
  ydif: number;
}

/**
 * Represents a static frame period (low variance)
 */
export interface StaticFeature {
  startTime: number;
  endTime: number;
  stdevY: number;
}

/**
 * Container for all highlight detection features
 */
export interface HighlightFeatures {
  cuts?: CutFeature[];
  flashes?: FlashFeature[];
  static?: StaticFeature[];
}

/**
 * Highlight entity matching backend Highlight model
 * Note: Highlights are returned as GetClipDto from the API,
 * but this type represents the full highlight entity structure
 */
export interface Highlight {
  id: number;
  fileId: number;
  projectId: number;
  startTime: number;
  score: number;
  features?: HighlightFeatures;
  method?: string;
  createdAt: string;
  updatedAt?: string;
}

/**
 * Highlight DTO matching backend GetClipDto
 * Used for API responses when highlights are returned as clip-like objects
 */
export interface HighlightDto {
  frontEndId: string;
  clipGroupId?: number;
  thumbnailUrl?: string;
  config?: ClipConfig;
  mediaFileId?: number;
  startTime?: number;
  endTime?: number;
  score?: number;
  isPinned: boolean;
}

/**
 * Response type for unpinned highlights
 * Highlights are returned as HighlightDto[] with isPinned=false
 */
export type GetUnpinnedHighlightsRes = HighlightDto[];

// S E R V I C E

/**
 * Fetches unpinned highlights for a story
 * Returns highlights that are not pinned in the story, filtered by sensitivity threshold
 * @param storyId - The story ID to get highlights for
 * @returns Promise resolving to array of HighlightDto representing unpinned highlights
 */
export const getUnpinnedHighlightsForStory = (storyId: StoryId) => {
  return api.get<GetUnpinnedHighlightsRes>(`/Highlight/GetUnpinnedHighlightsForStory?storyId=${storyId}`);
};
